import { Shield, Users, Clock } from "lucide-react";

const About = () => {
  const features = [
    {
      icon: Shield,
      title: "Insured & Registered",
      description: "Fully insured and in good standing",
    },
    {
      icon: Users,
      title: "Community Focused",
      description: "Proudly serving New Hampshire",
    },
    {
      icon: Clock,
      title: "Reliable Service",
      description: "Punctual and respectful crews",
    },
  ];

  return (
    <section id="about" className="py-20 bg-secondary">
      <div className="section-container">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="section-heading font-heading">About Hill Brothers</h2>
            <div className="w-20 h-1 bg-accent mx-auto rounded-full" />
          </div>
          
          <div className="space-y-6 text-lg text-muted-foreground mb-12">
            <p>
              Hill Brothers Painting & Contracting is a locally owned and operated business with deep roots in New Hampshire. We take pride in serving our neighbors, bringing professional-grade painting and contracting services to homes and businesses throughout the region.
            </p>
            <p>
              We stand behind every project we complete. Our commitment to quality means you can trust us to deliver exceptional results, on time and within budget. We treat every property as if it were our own.
            </p>
            <p>
              Our crews are punctual, respectful, and dedicated to keeping your space clean throughout the job. From the initial consultation to the final walkthrough, we're focused on your complete satisfaction. That's the Hill Brothers difference.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="bg-card p-6 rounded-xl text-center"
                style={{ boxShadow: "var(--shadow-md)" }}
              >
                <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="w-7 h-7 text-primary" aria-hidden="true" />
                </div>
                <h3 className="font-heading font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
